<template>
  <div style="flex: 1; padding: 20px">
    <el-page-header
      @back="goBack"
      :title="$t('admin.back')"
      :content="$t('admin.content')"
    ></el-page-header>
    <div class="tabs">
      <el-tabs
        v-model="adminActiveTab"
        type="border-card"
        style="flex: 1; display: flex; flex-direction: column"
      >
        <el-tab-pane v-if="checkPermission('readUser')" :label="$t('admin.users')" name="adminUsers">
          <TabUser />
        </el-tab-pane>
        <el-tab-pane v-if="checkPermission('readRole')" :label="$t('admin.role')" name="adminPermissions">
          <Role />
        </el-tab-pane>
        <el-tab-pane :label="$t('admin.duck')" name="duck">
          <Duck />
        </el-tab-pane>
        <!-- <el-tab-pane v-if="checkPermission('readTelemetry')" :label="$t('admin.telemetry')" name="adminTelemetry">
          <Telemetry />
        </el-tab-pane> -->
        <el-tab-pane v-if="checkPermission('readGateway')" :label="$t('admin.gateways')" name="adminGateways">
          <Gateway />
        </el-tab-pane>
        <el-tab-pane  :label="$t('admin.preferences')" name="preferences">
          <Preferences />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";
import TabUser from "./AdminTab_User.vue";
import Role from "./AdminTab_Role.vue";
// import Telemetry from "./AdminTab_Telemetry.vue";
import Gateway from "./AdminTab_Gateways";
import Trigger from "./AdminTab_Triggers";
import Preferences from "./AdminTab_Preferences";
import Duck from "./AdminTab_Duck";

export default {
  name: "Admin",
  components: { TabUser, Gateway, Trigger, Preferences, Role,Duck },
  data() {
    return {
      phoneNumber: null,
      results: {},
      adminActiveTab: "adminUsers",
    };
  },
  created() {
    this.loadCustomer();
  },
  computed: {
    ...mapState("account", ["user", "customer"])
  },
  methods: {
    ...mapActions("account", ["loadCustomer"]),
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
.el-dialog {
  margin-top: 15vh !important;
  width: 40% !important;
}
p {
  margin-left: 30px;
}
.el-form-item__content label.country-selector__label {
  line-height: normal;
}

.el-form-item__content label.input-tel__label {
  line-height: normal;
}
.vue-phone-number-input .select-country-container {
  min-width: 100px !important;
  max-width: 100px !important;
}
</style>
<style scoped>
.container {
  padding: 20px;
  margin-top: 0px;
  flex: 1;
  display: flex;
}
.tree-container {
  flex-basis: 20%;
  border: 1.5px solid #e4e7ed;
  margin-right: 10px;
}
.tabs {
  margin-top: 30px;
  flex-basis: 80%;
  display: flex;
}
.component {
  padding: 10px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ebebeb;
}
.component-container {
  margin: 0 10px 20px 10px;
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ebebeb;
  min-width: 300px;
  transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
  flex: 1 0 48%;
}
</style>